import type { Locale } from "@/service/LocaleService/LocaleService";
import { LangTypes } from "@/types/langTypes";

export const mapLangToLocale = (lang: LangTypes): Locale => {
    switch (lang) {
      case 'en':
        return 'en-US';
      case 'nl':
        return 'nl-NL';
      default:
        return 'fr-FR';
    }
};